import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerCreditMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('credits', locale)
}
